import React, { useState, useRef, useEffect } from "react";
import Hls from "hls.js";
import { motion } from "framer-motion";
// @ts-ignore
import videothumbnail from "../../Assets/Home/ElystrionExplanationVideoThumbnail.png";

const JoinElystrionSection = () => {
    const [clickerState, setClickerState] = useState(true);
    const [hasStarted, setHasStarted] = useState(false);
    const [fadeOutDiv, setfadeOutDiv] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const video = videoRef.current;
        const hlsUrl = process.env.REACT_APP_PORTAL_EXPLAIN_VIDEO_URL;

        if (video) {
            if (Hls.isSupported()) {
                const hls = new Hls();
                hls.loadSource(hlsUrl);
                hls.attachMedia(video);

                // optional: clean up on unmount
                return () => {
                    hls.destroy();
                };
            } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
                // Safari / iOS
                video.src = hlsUrl;
            }
        }
    }, []);

    useEffect(() => {
        handlePause();
    }, [])

    const handlePlay = () => {
        if (videoRef.current.requestFullscreen){
            videoRef.current.requestFullscreen();
        }
        videoRef?.current?.play();
        
    };

    const handlePause = () => {
        videoRef?.current?.pause();
    };

    const handleRestart = () => {
        if (videoRef?.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.play();
        }
    };

    const clickerHandler = () => {
        if (!hasStarted) {
            handlePlay();
            setHasStarted(true);
            setfadeOutDiv(true);
            setClickerState(false);
        } else {
            if (clickerState) {
                handlePlay();
            } else {
                handlePause();
            }
            setClickerState(!clickerState);
        }
    };

    const togglePlay = () => {
        if (!videoRef.current) return;

        if (videoRef.current.paused) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    };
    return (
        <section className="h-screen  m-auto m-0 pt-[60px] pb-[60px] xl:pt-[120px] xl:pb-[120px]" id="join-elystrion">
            <div className="inner-wrap max-w-[1700px] pl-[25px] pr-[25px] lg:pl-[25px] lg:pr-[25px] xl:pl-[50px] xl:pr-[50px] m-auto m-0">
                <p className="tag-line relative w-full items-center flex flex-col leading-tight">
                    <h2 className="text-[#f3daa3] text-[24px] sm:text-[24px] md:text-[30px] uppercase pb-[30px]">
                        Join Elystrion
                    </h2>
                    <h3 className="font-semi-bold text-[#CACACA] text-[40px] sm:text-[46px] md:text-[72px] adjust-width xl:w-4/6 text-center">
                        Grow Your Business with <span className="text-[#C4A050]">Trust and Transparency</span>
                    </h3>
                </p>
                <div className="content-block mt-[50px]">
                    <div className="slide-holder flex-row xl:flex xl:gap-12">
                        <div className="slide slide-01 flex-col gap-2  border-solid border border-[#F3DAA3] rounded-xl w-full xl:w-1/3 mb-[50px] xl:mb-[0] p-[30px]">
                            <h4 className="steps text-[#F3DAA3] text-[22px] sm:text-[22px] md:text-[26px] uppercase text-center w-full block relative">
                                <p>Chapter 1</p>
                            </h4>
                            <div className="top flex-col">
                                <span className="flex flex-row items-center justify-center pt-[30px] pb-[30px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none">
<path d="M83.336 45.5951V27.1951C83.336 23.2911 81.7848 19.5468 79.0245 16.7863C76.2641 14.0257 72.5197 12.4751 68.616 12.4751H24.4558C20.5518 12.4751 16.8077 14.0257 14.0472 16.7863C11.2867 19.5468 9.73584 23.2911 9.73584 27.1951V63.9951C9.73584 67.8992 11.2867 71.6428 14.0472 74.4036C16.8077 77.1639 20.5518 78.7151 24.4558 78.7151H46.536" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M80.3891 19.9453C59.7443 59.1004 33.2486 59.0636 12.6038 19.9453" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M57.5762 67.6753H87.0162" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M75.9761 56.6353L87.0161 67.6752L75.9761 78.7152" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <div className="bottom flex-col">
                                <p className="text-[#CACACA] text-[20px] sm:text-[20px] md:text-[24px] font-semi-bold w-full block text-center">The First Step Toward a Trusted Partnership</p><br></br>
                                <p className="text-[#CACACA] text-[18px] sm:text-[18px] md:text-[18px] w-full block text-center">Begin a trusted partnership with Elystrion, where authenticity meets innovation. Unlock new avenues of growth and elevate your brand 	within a verified ecosystem of excellence.</p>
                            </div>
                        </div>

                        <div className="slide slide-01 flex-col gap-2  border-solid border border-[#F3DAA3] rounded-xl w-full xl:w-1/3 mb-[50px] xl:mb-[0] p-[30px]">
                            <h4 className="steps text-[#F3DAA3] text-[22px] sm:text-[22px] md:text-[26px]  uppercase text-center w-full block relative">
                                <p>Chapter 2</p>
                            </h4>
                            <div className="top flex-col">
                                <span className="flex flex-row items-center justify-center pt-[30px] pb-[30px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none">
<path d="M26.9117 10.5415H11.0417V26.4115" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M81.9584 26.4115V10.5415H66.0884" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M66.0884 81.4584H81.9584V65.5884" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.7209 50.6191V71.7025H41.8043V50.6191H20.7209ZM26.8926 56.7908H35.7093V65.6075H26.8926V56.7908Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.7209 20.2207V41.304H41.8043V20.2207H20.7209ZM26.8926 26.3924H35.7093V35.209H26.8926V26.3924Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M51.1191 20.2207V41.304H72.2025V20.2207H51.1191ZM57.2908 26.3924H66.1075V35.209H57.2908V26.3924Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M61.6991 71.7791C64.3289 71.2833 66.6908 69.8538 68.35 67.7541C70.9868 64.7209 72.389 60.8084 72.2791 56.7908V50.6191H51.1958V56.7908C51.0897 60.8078 52.4914 64.719 55.125 67.7541C56.765 69.8382 59.0972 71.2661 61.6991 71.7791Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M61.6991 65.6077C60.9462 65.1423 60.2513 64.589 59.6291 63.9593C57.9761 61.9489 57.1412 59.3895 57.2908 56.791H66.1075C66.2517 59.392 65.4099 61.9517 63.75 63.9593C63.1278 64.589 62.4329 65.1423 61.68 65.6077H61.6991Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.0417 65.5884V81.4584H26.9117" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <div className="bottom flex-col">
                                <p className="text-[#CACACA] text-[20px] sm:text-[20px] md:text-[24px] font-semi-bold w-full block text-center">Crafting Enduring Business Relationships</p><br></br>
                                <p className="text-[#CACACA] text-[18px] sm:text-[18px] md:text-[18px] w-full block text-center">At Elystrion, partner engagement begins with trust. Through our meticulous KYB (Know Your Business) verification, we ensure every 	collaboration is founded on authenticity, compliance and long-term credibility.</p>
                            </div>
                        </div>

                        <div className="slide slide-01 flex-col gap-2  border-solid border border-[#F3DAA3] rounded-xl w-full xl:w-1/3 mb-[50px] xl:mb-[0] p-[30px]">
                            <h4 className="steps text-[#F3DAA3] text-[22px] sm:text-[22px] md:text-[26px]  uppercase text-center w-full block relative">
                                <p>Chapter 3</p>
                            </h4>
                            <div className="top flex-col">
                                <span className="flex flex-row items-center justify-center pt-[30px] pb-[30px]">

                                    <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none">
<path d="M78.875 14.375H14.125C11.3636 14.375 9.125 16.6136 9.125 19.375V72.625C9.125 75.3864 11.3636 77.625 14.125 77.625H78.875C81.6364 77.625 83.875 75.3864 83.875 72.625V19.375C83.875 16.6136 81.6364 14.375 78.875 14.375Z" stroke="#C4A050" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="37.875" cy="23" r="2.875" fill="#C4A050"/>
<circle cx="29.25" cy="23" r="2.875" fill="#C4A050"/>
<circle cx="20.625" cy="23" r="2.875" fill="#C4A050"/>
<path d="M9.125 31.625H83.875" stroke="#C4A050" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                </span>
                            </div>
                            <div className="bottom flex-col">
                                <p className="text-[#CACACA] text-[20px] sm:text-[20px] md:text-[24px] font-semi-bold w-full block text-center">Onboard to the Platform</p><br></br>
                                <p className="text-[#CACACA] text-[18px] sm:text-[18px] md:text-[18px] w-full block text-center">Following verification, you’ll be welcomed into the Elystrion ecosystem, with full access to our authentication technology, verification services, and a secure partner dashboard designed to empower your business growth.</p>
                            </div>
                        </div>
                    </div>
                    <div className="slide-holder flex-row xl:flex lg:mt-[80px] align-center justify-center xl:gap-12">
                        <div className="slide slide-01 flex-col gap-2  border-solid border border-[#F3DAA3] rounded-xl w-full xl:w-1/3 mb-[50px] xl:mb-[0] p-[30px]">
                            <h4 className="steps text-[#F3DAA3] text-[22px] sm:text-[22px] md:text-[26px]  uppercase text-center w-full block relative">
                                <p>Chapter 4</p>
                            </h4>
                            <div className="top flex-col">
                                <span className="flex flex-row items-center justify-center pt-[30px] pb-[30px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none">
<path d="M81 61.3333V30.6667L65.6667 11.5H27.3333L12 30.6667V61.3333L27.3333 80.5H65.6667L81 61.3333Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M65.6666 56.2225V36.4168L57.9999 26.8335H34.9999L27.3333 36.4168V56.2225L34.9999 65.1668H57.9999L65.6666 56.2225Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27.3333 80.4998L34.9999 65.1665" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M58 65.1665L65.6667 80.4998" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27.3333 11.5L34.9999 26.8333" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M58 26.8333L65.6667 11.5" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 30.6665L27.3333 36.4165" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 61.3335L27.3333 55.5835" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M81.0001 61.3335L65.6667 55.5835" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M65.6667 36.4165L81.0001 30.6665" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <div className="bottom flex-col">
                                <p className="text-[#CACACA] text-[20px] sm:text-[20px] md:text-[24px] font-semi-bold w-full block text-center">Authenticate Products</p><br></br>
                                <p className="text-[#CACACA] text-[18px] sm:text-[18px] md:text-[18px] w-full block text-center">Verify and certify your products on Elystrion to establish authenticity, strengthen buyer confidence, and promote transparent transactions.</p>
                            </div>
                        </div>

                        <div className="slide slide-01 flex-col gap-2  border-solid border border-[#F3DAA3] rounded-xl w-full xl:w-1/3 mb-[50px] xl:mb-[0] p-[30px]">
                            <h4 className="steps text-[#F3DAA3] text-[22px] sm:text-[22px] md:text-[26px]  uppercase text-center w-full block relative">
                                <p>Chapter 5</p>
                            </h4>
                            <div className="top flex-col">
                                <span className="flex flex-row items-center justify-center pt-[30px] pb-[30px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none">
<path d="M39.597 45.9998C50.1824 45.9998 58.7637 37.4186 58.7637 26.8332C58.7637 16.2477 50.1824 7.6665 39.597 7.6665C29.0116 7.6665 20.4304 16.2477 20.4304 26.8332C20.4304 37.4186 29.0116 45.9998 39.597 45.9998Z" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.33325 84.3333C6.51971 76.7939 11.0337 70.1389 17.23 65.3196C23.4264 60.5003 30.9878 57.7633 38.8333 57.5C54.6266 57.5 68.0816 68.655 73.3333 84.3333" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M68.812 17.02C71.7318 18.5171 74.0947 20.9113 75.5529 23.851C77.0111 26.7906 77.4879 30.1203 76.9129 33.351C76.3379 36.5817 74.7417 39.5425 72.3589 41.7988C69.9765 44.0548 66.9325 45.4869 63.6753 45.8848" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M66.8945 55.8521C72.0082 57.155 76.6987 59.7552 80.5128 63.4018C84.3274 67.0481 87.1361 71.617 88.6679 76.6667" stroke="#C4A050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <div className="bottom flex-col">
                                <p className="text-[#CACACA] text-[20px] sm:text-[20px] md:text-[24px] font-semi-bold w-full block text-center">Join the Marketplace</p><br></br>
                                <p className="text-[#CACACA] text-[18px] sm:text-[18px] md:text-[18px] w-full block text-center">Connect with trusted partners and verified resellers through the Elystrion Marketplace to expand your reach and accelerate business growth.</p>
                            </div>
                        </div>
                    </div>

                    <div className="flex align-center justify-center mt-[50px] mb-[50px]">
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="66" height="73" viewBox="0 0 66 73" fill="none">
                            <path d="M33 71.7107V1M33 71.7107L64.8198 39.8909M33 71.7107L1.18018 39.8909" stroke="#F3DAA3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> */}
                        <h2 className="font-semibold text-[#CACACA] text-[24px] sm:text-[24px] md:text-[30px] pt-[30px] pb-[0] text-center lg:w-[60%] xl:w-[50%]">
                            Experience the Essence of Elystrion, <span className="text-[#C4A050]">Where a New Standard Begins.</span>
                        </h2>
                    </div>



                    <div className="right w-full xl:w-3/4 mt-[50px] xl:mt-[0] mx-auto relative">
                        <div className="absolute w-full h-full top-0 left-0 bg-[rgba(0,0,0,0.3)] z-10"></div>
                        {/* <span className="text-[#CACACA] text-[28px] sm:text-[36px] md:text-[52px] adjust-width font-semi-bold leading-tight text-center mb-[50px] mt-[50px] w-full">
                                Sub Title
                     </span> */}
                        {!hasStarted && (
                            <div className="video-holder xl:rounded-3xl relative bg-no-repeat cursor-pointer">
                                <span className="play z-20">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="121" viewBox="0 0 120 121" fill="none" onClick={clickerHandler}>
                                        <rect y="0.710938" width="120" height="120" rx="60" fill="#F3DAA3" fill-opacity="0.2" />
                                        <path d="M50.8535 42.418V79.0033L78.2925 60.7107L50.8535 42.418Z" stroke="white" stroke-width="3.04878" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </div>
                        )}

                    </div>

                    <motion.video
                        // @ts-ignore
                        className={`${!hasStarted ? 'hidden' : 'block relative inset-0 w-full h-full object-cover'}`}
                        ref={videoRef}
                        // playsInline
                        controls
                        onEnded={() => {
                            setTimeout(() => {
                                if (document.fullscreenElement) {
                                    document.exitFullscreen?.().catch(() => { });
                                } else if ((document as any).webkitFullscreenElement) {
                                    (document as any).webkitExitFullscreen?.();
                                }
                                setHasStarted(false);
                                setfadeOutDiv(false);
                                if (videoRef.current) {
                                    videoRef.current.pause();      // stop video
                                    videoRef.current.currentTime = 0; // rewind to start
                                }
                            }, 600); // match your fade duration
                        }}
                        initial={{ opacity: 0, scale: 1.05 }}
                        animate={{ opacity: !hasStarted ? 0 : 1, scale: 1 }}
                        transition={{ duration: 1.5, ease: "easeOut" }}
                    >
                        Your browser does not support the video tag.
                    </motion.video>
                </div>

                {/* <div className="nav slider-nav xl:hidden mt-[50px]">
                    <ul className="flex gap-6 items-center mt-[30px]">
                        <li className="">
                            <div className="progress-bar w-40 h-3 bg-[#CACACA] relative rounded-3xl">
                                <div className="progress w-20 h-3 bg-[#F3DAA3] absolute rounded-3xl"></div>
                            </div>
                        </li>
                        <li><svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none">
                            <g opacity="0.5">
                                <rect y="0.707107" width="71" height="71" rx="35.5" transform="matrix(-0.707107 0.707107 0.707107 0.707107 50.4121 0.207107)" stroke="#CACACA" />
                                <path d="M36.77 50.9117H65.0542M36.77 50.9117L49.4979 38.1837M36.77 50.9117L49.4979 63.6396" stroke="#CACACA" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                        </svg></li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none">
                                <g opacity="0.5">
                                    <rect x="50.9121" y="0.707107" width="71" height="71" rx="35.5" transform="rotate(45 50.9121 0.707107)" stroke="#CACACA" />
                                    <path d="M65.0542 50.9117H36.77M65.0542 50.9117L52.3263 38.1837M65.0542 50.9117L52.3263 63.6396" stroke="#CACACA" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                            </svg>
                        </li>
                    </ul>
                </div> */}

            </div>

        </section>
    );
};

export default JoinElystrionSection;